import LoginStore from './LoginStore';
import ThemeStore from './ThemeStore';
import IntroStore from './IntroStore';
import DeskTopStore from './DeskTopStore';

const portalLoginStore = new LoginStore();
const portalThemeStore = new ThemeStore();
const portalIntroStore = new IntroStore();
const portalDeskTopStore = new DeskTopStore();

export default {
  portalLoginStore,
  portalThemeStore,
  portalIntroStore,
  portalDeskTopStore,
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/stores/index.js